export default __webpack_public_path__ + "static/blob5-8c2843ef98d0df6d209f64793a4cd921.svg";